import { useEffect, useState } from 'react'
import './Payment.css'
import Logo from '../../components/Logo/Logo'
import { Footer } from './Footer'

export const Error = () => {
    const email = new URL(document.location).searchParams.get('email')

    useEffect(() => {
        document.title = 'Неудачная оплата'
    }, [])


    return (
        <>
            <div className="container mx-auto py-4 md:py-6 lg:py-8 px-3 sm:px-0">
                <div className="card px-4 md:px-5 lg:px-6">
                    <>
                        <div className="grid justify-content-between px-2">
                            <div className={'col-12 flex'}>
                                <div className="flex flex-column justify-content-between w-full lg:pr-6 lg:pl-5">
                                    <div className={'grid'}>
                                        <div className={'col-12 flex flex-column justify-content-between'}>
                                            <div className="mb-5">
                                                <h3 className="mb-5 title">Не удалось обработать платеж</h3>
                                                <p className="">Напишите в службу заботы <a href='mailto:mail@ashahov.ru'>mail@ashahov.ru</a> или нам в директ <a href='https://www.instagram.com/shahov.helper/'>@shahov.helper</a>, мы постараемся решить проблему.</p>
                                            </div>

                                            <div className={'label up justify-content-center md:justify-content-start w-full hidden md:flex'}>
                                                <Logo data={{ company: '<b>Добро пожаловать!</b>' }} />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </>
                </div>
                <Footer dataSite={{ company: '<b>Добро пожаловать!</b>' }} />
            </div>
        </>
    )
}
